import { render, staticRenderFns } from "./WeiboTable.vue?vue&type=template&id=3be6cfc2&scoped=true&"
import script from "./WeiboTable.vue?vue&type=script&lang=js&"
export * from "./WeiboTable.vue?vue&type=script&lang=js&"
import style0 from "./WeiboTable.vue?vue&type=style&index=0&id=3be6cfc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be6cfc2",
  null
  
)

export default component.exports